import { map, Observable } from 'rxjs';
import { DocumentService } from 'src/app/services/document.service';
import { DocumentDetailsFilters, DocumentGroup, GroupedDocument } from './document-details.models';

interface GroupedDocumentsResponse {
  group: string;
  documents?: Array<{
    id: string;
    originalFilename: string;
    type: string;
    user: string;
    createdAt: string;
    publicUrl?: string;
  }>;
}

export class DocumentListCoordinator {
  constructor(private readonly documents: DocumentService) {}

  load(): Observable<DocumentGroup[]> {
    return this.documents.getGroupedDocumentsByDate().pipe(
      map((groups: GroupedDocumentsResponse[]) => groups.map((group) => ({
        group: group.group,
        documents: (group.documents || []).map((document) => ({
          id: document.id,
          original_filename: document.originalFilename,
          type: document.type,
          user: document.user,
          created_at: document.createdAt,
          publicUrl: document.publicUrl || ''
        }))
      })))
    );
  }

  delete(documentId: string) {
    return this.documents.deleteDocument(documentId);
  }

  filter(groups: DocumentGroup[], filters: DocumentDetailsFilters): DocumentGroup[] {
    let filtered = groups;
    if (filters.type) {
      const expectedExtension = filters.type.replace('.', '').toLowerCase();
      filtered = this.filterGroups(filtered, (document) => {
        const extension = document.original_filename.split('.').pop()?.toLowerCase();
        return extension === expectedExtension;
      });
    }
    if (filters.documentIds?.length) {
      const selectedIds = new Set(filters.documentIds);
      filtered = this.filterGroups(filtered, (document) => selectedIds.has(document.id));
    }
    return filtered;
  }

  private filterGroups(
    groups: DocumentGroup[],
    predicate: (document: GroupedDocument) => boolean
  ): DocumentGroup[] {
    return groups
      .map((group) => ({ ...group, documents: group.documents.filter(predicate) }))
      .filter((group) => group.documents.length > 0);
  }
}
